export default __webpack_public_path__ + "static/media/clairefontaine13.7f39bce3.jpg";